// extracted by mini-css-extract-plugin
export default {"viewButton":"IpAddressesCellRenderer_viewButton__33765"};